<template>
  <div class="main_container">
    <div class="main_container__upload_content">
      <div class="header">KML Converter</div>
      <div v-if="pickingFile" class="main_container__upload_content__upload-view">
        <input
          type="file"
          multiple
          name="fields[assetsFieldHandle][]"
          id="assetsFieldHandle"
          class="form-file"
          @change="onChange"
          ref="file"
          accept=".csv"
        />
        <label for="assetsFieldHandle">
          <div
            class="drop-section cursor-leave"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
          >
            <div class="upload-here">Upload File Here</div>
            <div
              class="description"
            >Allowed File is csv only, tips you can drop single or multiple file here</div>
          </div>
        </label>
        <div class="uploaded-file">
          <div v-if="files.length > 0" class="list-file">
            <div class="header">File Uploaded</div>
            <div v-for="(file, index) in files" class="file-csv" :key="file._id">
              <div class="number">{{index + 1}}.</div>
              <div class="file-name">{{file.name}}</div>
              <div class="icon-wrapper" @click="remove(index)">
                <i class="icon-deleted"></i>
              </div>
            </div>
            <div class="line-wrapper">
              <hr class="line" />
            </div>
          </div>
          <button
            @click="uploadCSV()"
            class="btn-large primary converter-trigger"
          >Convert & Download as KML File</button>
        </div>
      </div>
      <div v-if="progressing" class="main_container__upload_content__progressing-view">
        <loading-primary class="loading-state" />
        <div class="progress-text">On Progress | Please wait . . .</div>
      </div>
      <div v-if="uploaded" class="main_container__upload_content__finished-view">
        <img class="uploaded-icon" src="/img/icon-checklist.png" alt="Done" />
        <div class="success-title">Convert Success</div>
        <div class="success-caption">
          Awesome team, your kml file already downloaded!
          Check your download history to open that file.
        </div>
        <button @click="showPickingWindow()" class="btn-large primary create-new">Convert New KML</button>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPrimary from "@/components/Loading/Primary";
import api from "@/api";
import { apiV2 } from "@/api/urls";
import FileSaver from "file-saver";

export default {
  name: "adx-kml-converter",
  components: {
    "loading-primary": LoadingPrimary
  },
  data() {
    return {
      pickingFile: true,
      progressing: false,
      uploaded: false,
      files: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    async uploadCSV() {
      if (this.files.length > 0) {
        this.showProgressWindow();
        let formData = new FormData();
        this.files.forEach(file => {
          formData.append("csv", file);
        });

        const response = await api.post(apiV2.csvToKml, formData, {
          needToken: true,
          headers: { "Content-Type": "multipart/form-data" },
          responseType: "blob"
        });
        this.showProgressWindow();
        if (response.status == 200) {
          let fileName = `route-data.kml`;
          await FileSaver.saveAs(response.data, fileName);
          this.showFinishWindow();
          this.files = [];
        } else {
          let error = "Bad Request";
          if (response.status === 403) error = "Forbidden";
          if (response.status === 500) error = "Internal Server Error";
          this.showPickingWindow();
          this.$notify({
            group: "saved",
            title: "Error",
            text: error,
            type: "danger"
          });
        }
      } else {
        this.$notify({
          group: "saved",
          title: "Error",
          text: "Pick a csv file first.",
          type: "danger"
        });
      }
    },
    showProgressWindow() {
      this.progressing = true;
      this.pickingFile = false;
      this.uploaded = false;
    },
    showFinishWindow() {
      this.uploaded = true;
      this.progressing = false;
      this.pickingFile = false;
    },
    showPickingWindow() {
      this.pickingFile = true;
      this.uploaded = false;
      this.progressing = false;
    },
    onChange() {
      let tmpFiles = [...this.$refs.file.files];
      tmpFiles.forEach(file => {
        if (this.getFileExt(file.name) == "csv") {
          this.files.push(file);
        } else {
          this.$notify({
            group: "saved",
            title: "Error",
            text: "Only accept csv file.",
            type: "danger"
          });
        }
      });
    },
    getFileExt(filename) {
      return filename.split(".").pop();
    },
    remove(i) {
      this.files.splice(i, 1);
      this.$refs.file.value = null;
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("cursor-over")) {
        event.currentTarget.classList.remove("cursor-leave");
        event.currentTarget.classList.add("cursor-over");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("cursor-leave");
      event.currentTarget.classList.remove("cursor-over");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("cursor-leave");
      event.currentTarget.classList.remove("cursor-over");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>